import React from "react";
import "./DiscoverUs.scss";
import LazyImage from "../../LazyImage/LazyImage";
import Button from "../../Button/Button";
import {
  HiTruck,
  HiMusicalNote,
  HiCamera,
  HiPhoto,
  HiShieldCheck,
} from "react-icons/hi2";

import aboutImage from "../../../assets/images/great-hall/greatHall51.jpg";

export default function DiscoverUs({ t }) {
  const discoverData = [
    {
      title: t("discover_item1_title"),
      description: t("discover_item1_description"),
      icon: <HiTruck />,
    },
    {
      title: t("discover_item2_title"),
      description: t("discover_item2_description"),
      icon: <HiMusicalNote />,
    },
    {
      title: t("discover_item3_title"),
      description: t("discover_item3_description"),
      icon: <HiCamera />,
    },
    {
      title: t("discover_item4_title"),
      description: t("discover_item4_description"),
      icon: <HiPhoto />,
    },
    {
      title: t("discover_item5_title"),
      description: t("discover_item5_description"),
      icon: <HiShieldCheck />,
    },
  ];
  return (
    <div className="discover-us">
      <div className="discover-us__about">
        <div className="content">
          <h1>{t("about_us_title")}</h1>
          <p>{t("about_us_description")}</p>
          <Button
            text={t("about_us_button")}
            variant={"primary"}
            to={"/about-us"}
          />
        </div>
        <div className="image">
          <LazyImage src={aboutImage} alt="About us image" />
        </div>
      </div>
      <div className="discover-us__content">
        <h1>{t("discover_title")}</h1>
        <div className="item-list">
          {discoverData.map((discover) => (
            <div key={discover.title} className="item">
              <span>{discover.icon}</span>
              <h3>{discover.title}</h3>
              <p>{discover.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
